import { PersonData } from '@tymbe/schema/person.interface';
import { useFormState, useFormApi } from 'informed';

import TyInput from '../../../components/inputs/TyInput';
import TySelectPerson from '../../../components/inputs/TySelectPerson';
import { addPlusToPhone } from '../../../utils/phoneNumber';
import { Roles } from '@tymbe/schema/enums';

type TymbeContactFormProps = {
  initialTymbeContact?: PersonData;
};

export interface TymbeContactFormValues {
  contactTymbe?: PersonData;
  contactTymbePosition?: string;
  contactTymbeEmail?: string | null;
  contactTymbePhone?: string | null;
}

const getNumberFromContact = (contactPerson?: PersonData): string | undefined => addPlusToPhone(
  contactPerson?.contact?.find((c) => c.type === 'mobile_phone')?.value,
);

const getEmail = (contactPerson?: PersonData): string | null | undefined => contactPerson?.login?.username
  ?? contactPerson?.contact?.find((c) => c.type === 'email')?.value;

const TymbeContactForm = ({ initialTymbeContact }: TymbeContactFormProps) => {
  const formState = useFormState<TymbeContactFormValues>();
  const formApi = useFormApi<TymbeContactFormValues>();

  const onSelectPerson = () => {
    const { contactTymbe } = formState.values;
    if (!contactTymbe) {
      formApi.clearValue('contactTymbePosition');
      formApi.clearValue('contactTymbeEmail');
      formApi.clearValue('contactTymbePhone');
      return;
    }

    formApi.setValue('contactTymbePosition', contactTymbe.company?.[0]?.title ?? '');
    formApi.setValue('contactTymbeEmail', getEmail(contactTymbe) ?? '');
    formApi.setValue('contactTymbePhone', getNumberFromContact(contactTymbe) ?? '');
  };

  return (
    <div className="flex lg:flex-row flex-col gap-10">
      <div className="flex flex-col gap-2 lg:min-w-[42%]">
        <h3 className="text-heading-4-xl">Kontaktní osoba Tymbe</h3>
        <TySelectPerson name="contactTymbe" filter={{ role: [Roles.TYMBE_ADMIN, Roles.TYMBE_COORDINATOR, Roles.ADMIN, Roles.SUPER_ADMIN] }} onChange={onSelectPerson} isClearable />
        <div className="flex flex-row gap-2 flex-wrap">
          <TyInput
            className="w-full md:flex-1"
            name="contactTymbe.first_name"
            label="Jméno kontaktní osoby"
            disabled
          />
          <TyInput
            className="w-full md:flex-1"
            name="contactTymbe.last_name"
            label="Příjmení kontaktní osoby"
            disabled
          />
        </div>
        <TyInput
          name="contactTymbePhone"
          label="Mobil"
          disabled
          initialValue={getNumberFromContact(initialTymbeContact)}
        />
        <TyInput
          name="contactTymbeEmail"
          label="Email"
          disabled
          initialValue={getEmail(initialTymbeContact)}
        />
        <TyInput
          name="contactTymbePosition"
          label="Pozice"
          disabled
          initialValue={initialTymbeContact?.company?.[0]?.title}
        />
      </div>
    </div>
  );
};

export default TymbeContactForm;
